<template>
  <div class="header">
    <!-- 导航栏部分 -->
    <div class="nav-list">
      <div class="nav-item">
        <router-link to="/home/publish-news">发布新闻</router-link>
      </div>
      <div class="nav-item">
        <router-link to="/home/check-news">新闻管理</router-link>
      </div>
      <div class="nav-item">
        <router-link to="/home/recruitment">招聘信息管理</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { computed } from 'vue'

// 获取 router 实例
const router = useRouter()
// 获取 store 实例
const store = useStore()

// Vuex 的 actions 映射
const setUser = (payload) => store.dispatch('setUser', payload)
const setUserId = (payload) => store.dispatch('setUserId', payload)

// 处理下拉菜单命令
function handleCommand(command) {
  if (command === 'getUserInfo') {
    getUserInfo()
  } else if (command === 'logout') {
    logout()
  }
}

// 跳转个人信息页
function getUserInfo() {
  router.push('/home/user-infomation')
}

// 退出登录，清空 Vuex 并跳转登录页
function logout() {
  setUser('')
  setUserId('')
  router.push('/login')
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// 导航栏部分
.nav-list {
  width: 600px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-left: 50px;
}
.nav-list .nav-item {
  position: relative;
}
.nav-list .nav-item::before {
  display: block;
  content: "";
  width: 0.5px;
  height: 50%;
  position: absolute;
  top: 50%;
  left: 0;
  background-color: #2d2e30;
  transform: translate(-20px, -50%);
}
.nav-list .nav-item a {
  text-decoration: none;
  color: #ffffff;
}
// 个人中心部分
.user-info {
  margin-right: 50px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
}
.el-icon-arrow-down {
  font-size: 16px;
}
</style>
